export default __webpack_public_path__ + "static/media/1923.38b3c888.png";